module.exports = __webpack_public_path__ + "icons/original/large/large-c3.82043ba3661fa5a9afc87cf0c1d9f917.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-c3.png
// module id = XjqR
// module chunks = app